module.exports = __webpack_public_path__ + "img/sparks-05.cbb6aec6.png";